import * as React from 'react'
import MaskedInput from 'react-text-mask';

export function getDescendantProp(obj: any, desc: string) {
    var arr: string[] = desc.split(".");
    while (arr.length) {
        let next = arr.shift()

        if (next === undefined)
            break

        if (obj === null || obj[next] === undefined) {
            console.log("No property " + next)
            break;
        }

        obj = obj[next]
    }

    return obj;
}

const patternEm = /\<em\>/g
const patternEmend = /\<\/em\>/g
export function renderSolrHighlightedResult(searchValue: string, highlighted: string[] | undefined, productName: string) {    
    if (searchValue !== '' && highlighted !== undefined && highlighted.length > 0) {
            return (
                <span dangerouslySetInnerHTML={{ __html: highlighted[0].replace(patternEm, '<b>').replace(patternEmend, '</b>') }}></span>
            )
        }
        else
            return (
                <span>{productName}</span>
            )
}


export function TextMaskCustom(props: any, mask: any[]) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={mask}
            placeholderChar={'_'}
        />
    );
}